import type { VoiceInput } from '../hooks/useVoiceInput';

export interface VoiceButtonProps {
    voice: VoiceInput;
    /** Wat de knop zegt zolang hij niet opneemt: "Spreek bevinding in". */
    idle: string;
    recording: string;
    /** Wat er staat als het apparaat geen spraak kent; typen blijft over. */
    unavailable: string;
    /** De toegankelijke naam, als de tekst op de knop niet zegt waar hij bij hoort. */
    label?: string;
}

/**
 * De spraakknop naast een veld: 44 px hoog, en rood zolang hij opneemt - de
 * enige plek in de opname waar rood "er loopt iets" betekent in plaats van
 * "er is iets mis" (patterns.md §2). Typen op een tablet met werkhandschoenen
 * aan is het echte knelpunt, dus de knop staat er altijd bij, met tekst.
 */
export function VoiceButton({ voice, idle, recording, unavailable, label }: VoiceButtonProps) {
    if (!voice.supported) {
        return <span className="text-[11px] text-[var(--text-tertiary-safe)]">{unavailable}</span>;
    }

    return (
        <button
            type="button"
            aria-pressed={voice.recording}
            {...(label ? { 'aria-label': label } : {})}
            onClick={voice.toggle}
            className="min-h-[44px] shrink-0 cursor-pointer rounded-[7px] border px-[13px] font-[family-name:var(--font-body)] text-[12px] outline-offset-2 focus-visible:outline-2 focus-visible:outline-[var(--accent)]"
            style={
                voice.recording
                    ? {
                          borderColor: 'var(--danger)',
                          background: 'var(--danger-tint)',
                          color: 'var(--danger)',
                      }
                    : {
                          borderColor: 'var(--border-control)',
                          background: 'var(--surface-card)',
                          color: 'var(--text-secondary)',
                      }
            }
        >
            {voice.recording ? recording : idle}
        </button>
    );
}
